/* eslint-disable max-len */
/* eslint-disable no-console */
import Litepicker from 'litepicker';
import {
  addDays,
} from 'date-fns';

export default function init() {
  /* The original element that requested the module */
  const context = document.querySelector('[data-delivery]');
  const mql = window.matchMedia('(min-width: 768px)');

  /* Context sensitive things to target */
  const selectors = {
    picker: '[data-delivery-picker]',
    confirm: '[data-delivery-confirm]',
    deliveryDate: '[data-delivery-date]',
    collectionDate: '[data-delivery-collection-date]',
    paymentButtons: 'product_payments_btns',
    permits: '[data-option-handle="is-the-skip-going-to-be-placed-on-a-road"] [type="radio"]',
    permitsSelected: '[data-option-handle="is-the-skip-going-to-be-placed-on-a-road"] :checked',
    hirePeriods: '[data-option-handle="hire-period"] [type="radio"]',
    hirePeriodSelected: '[data-option-handle="hire-period"] :checked',
  };

  /* Find all of the above */
  const elements = {
    picker: context.querySelector(selectors.picker),
    confirm: context.querySelector(selectors.confirm),
    deliveryDate: context.querySelector(selectors.deliveryDate),
    collectionDate: context.querySelector(selectors.collectionDate),
    paymentButtons: document.querySelector(`.${selectors.paymentButtons}`),
    permits: document.querySelectorAll(selectors.permits),
    permitsSelected: () => document.querySelector(selectors.permitsSelected),
    hirePeriods: document.querySelectorAll(selectors.hirePeriods),
    hirePeriodSelected: () => document.querySelector(selectors.hirePeriodSelected),
  };

  const options = {
    range: (context.dataset.deliveryRange === 'true'),
    disabledDays: JSON.parse(context.dataset.deliveryDisabledDates),
    allowedDays: JSON.parse(context.dataset.deliveryAllowedDays),
    variantsToDays: JSON.parse(context.dataset.deliveryVariantsToDays),
    cutOffDays: parseInt(context.dataset.deliveryCutOffDays, 10),
    collectionCutOffDays: parseInt(context.dataset.deliveryCollectionCutOffDays, 10),
    haveOverrideDates: (context.dataset.deliveryOverrideDates !== ''),
    overrideDates: (context.dataset.deliveryOverrideDates !== '') ? JSON.parse(context.dataset.deliveryOverrideDates) : '',
  };

  const getStartDate = () => {
    if (elements.permits.length === 0) return 0;

    const requiresPermit = elements.permitsSelected().value === 'Yes';
    return requiresPermit ? 7 : 0;
  }


  const today = () => new Date(); //'Fri Dec 24 2021 10:43:36 GMT+0000 (Greenwich Mean Time)'
  const logStyle = 'color: #eb6a2e; font-weight: bold;';
  // const maxCollectionDate = addDays(today(), options.collectionCutOffDays);
  const formatDate = (date) => `${date.getDate()}/${(date.getMonth() + 1)}/${date.getFullYear()}`;
  const formatToGBDate = (date) => new Intl.DateTimeFormat('en-GB').format(date);
  const theStartDate = getStartDate();
  const maxDate = addDays(today(), options.cutOffDays + theStartDate);

  if (!elements.picker) return;

  const getNextDeliveryDate = () => {
    const theStartDate = getStartDate();
    const maxDate = addDays(today(), options.cutOffDays + theStartDate);
    let nextDeliveryDateAdjustment = (today().getHours() >= 10) ? 1 + theStartDate : theStartDate;
    let nextDeliveryDate = addDays(today(), nextDeliveryDateAdjustment);

    if (options.disabledDays !== '') {
      // nextDeliveryDate = new Date('Thur Dec 30 2021 08:00:00');
      const theStartDate = getStartDate();
      const end = new Date(maxDate);
      let loop = new Date(addDays(today(), theStartDate));

      while (loop <= end) {
        const newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
        const formattedCalendarDate = formatToGBDate(loop);

        if (!options.disabledDays.includes(formattedCalendarDate)) {
          const potentialNextDeliveryDate = loop;
          const potentialNextDeliveryDay = potentialNextDeliveryDate.getDay();
          const isAllowedDay = options.allowedDays.includes(potentialNextDeliveryDay);

          if (isAllowedDay) {
            nextDeliveryDate = loop;
            break;
          }
        }
      }
    }

    return nextDeliveryDate;
  }

  const nextDeliveryDate = getNextDeliveryDate();

  const settings = {
    common: {
      element: elements.picker,
      format: 'DD/MM/YYYY',
      lockDaysFormat: 'DD/MM/YYYY',
      lockDays: options.disabledDays,
      startDate: nextDeliveryDate,
      minDate: addDays(nextDeliveryDate, -1),
      maxDate,
      lang: 'en-GB',
      numberOfMonths: 2,
      numberOfColumns: 2,
      position: 'bottom right',
      setup: (picker) => {
        picker.on('selected', (date1, date2) => {
          if (options.range) {
            const { dateInstance: deliveryDate } = date1;
            elements.deliveryDate.value = formatToGBDate(deliveryDate);
            const { dateInstance: collectionDate } = date2;
            elements.collectionDate.value = formatToGBDate(collectionDate);
          } else {
            const { dateInstance: collectionDate } = date1;
            elements.collectionDate.value = formatToGBDate(collectionDate);
          }

          enableDisablePaymentButtons(true);
        });

        picker.on('clear:selection', () => {
          // const maxDays = getMaxDays();
          const maxDate = addDays(today(), options.cutOffDays);
          if (options.range) {
            elements.deliveryDate.value = '';
          }
          elements.collectionDate.value = '';

          picker.setOptions({
            maxDate,
          });
        })

        picker.on('preselect', (date1, date2) => {
          if (options.range && date2 === undefined) {
            const maxDays = getMaxDays();
            const maxDate = addDays(date1.dateInstance, maxDays);

            picker.setOptions({
              maxDate,
            });
            picker.gotoDate(date1);
          }
        })
      },
    },
    single: {
      singleMode: true,
    },
    range: {
      singleMode: false,
      maxDays: 14,
      resetButton: true,
      lockDaysFilter: (date) => {
        const { dateInstance } = date;
        const compareDate = new Date(dateInstance);
        const calendarDayOfWeek = dateInstance.getDay();
        const dateToCompareOverride = formatDate(compareDate);

        let isAllowedDay = !options.allowedDays.includes(calendarDayOfWeek);

        if (options.haveOverrideDates && options.overrideDates.find((element) => element === dateToCompareOverride) !== undefined) {
          console.info('%c📦 Override dates have been set.', logStyle)
          isAllowedDay = false;
        }

        return isAllowedDay;
      },
    }
  }

  const merged = {
    ...settings.common,
    ...(options.range ? settings.range : settings.single)
  };

  // eslint-disable-next-line no-unused-vars
  const picker = new Litepicker(merged);

  const getMaxDays = () => {
    const days = options.variantsToDays.find((key) => {
      const array = key.split(':');
      return array[1] === elements.hirePeriodSelected().value;
    });

    const daysVariant = days.split(':');
    return parseInt(daysVariant[0], 10);
  }

  const updateHirePeriod = () => {
    const startDate = getNextDeliveryDate();
    const maxDays = getMaxDays();
    const settings = {
      maxDays,
      startDate: startDate,
      minDate: addDays(startDate, -1),
    }

    updateSettings(settings);
  }

  const updateSettings = (settings) => {
    picker.clearSelection();
    picker.setOptions(settings);
    console.info(`%c📦 Updating start date to ${formatToGBDate(settings.startDate.dateInstance)}`, logStyle);
    console.info(`%c📦 Updating max hire period to ${settings.maxDays} days`, logStyle);
  }

  const enableDisablePaymentButtons = (disable) => {
    const action = disable ? 'add' : 'remove';
    elements.paymentButtons.classList[action]('is-disabled');
  }

  const setInitialDeliveryDate = () => {
    if (!options.range) {
      elements.collectionDate.value = formatToGBDate(nextDeliveryDate);
    }
  }

  // Bind events
  if (options.range && elements.hirePeriods && elements.permits) {
    const combined = new Set([
      ...elements.hirePeriods,
      ...elements.permits
    ])
    combined.forEach((element) => {
      element.addEventListener('change', (event) => {
        updateHirePeriod();
      })
    })
  }

  if (elements.paymentButtons) {
    enableDisablePaymentButtons(true);
  }

  if (elements.confirm) {
    elements.confirm.addEventListener('change', () => {

      if (picker.getStartDate() === null) {
        elements.picker.classList.add('is-required');
        elements.confirm.checked = false;
        return;
      }

      elements.picker.classList.remove('is-required');
      enableDisablePaymentButtons(!elements.confirm.checked);
    });
  }

  // Update hire period on load
  window.addEventListener('load', () => {
    options.range && updateHirePeriod();

    setInitialDeliveryDate();
  });

  window.addEventListener('resize', () => {
    const options = {
      numberOfColumns: 1
    }
    if (mql.matches) {
      options.numberOfColumns = 2;
    }
    picker.setOptions(options);
  })
}
